// @ts-ignore

const BASE_CONTENT_URL_KEY = 'base.content.url';

export const BASE_CONTENT_URL =
	localStorage?.getItem(BASE_CONTENT_URL_KEY) ||
	'https://static.descope.com/pages';

export const ASSETS_FOLDER = 'v2-beta';

export const CONFIG_FILENAME = 'config.json';

export const WC_NAME = 'descope-wc';

export const FLOWS_V2_SDK_URL =
	'https://cdn.jsdelivr.net/npm/@descope/web-component@3.0.0-alpha.6';
